import React from "react";
import { PageMeta } from "@/components/PageMeta";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CtaBand } from "@/components/CtaBand";
import { BRAND, TRUST_POINTS, IMAGES } from "@/config/brand";
import { CheckCircle2 } from "lucide-react";

export default function About() {
    return (
        <div>
            <PageMeta title="About YS Removals — London Removals" description="YS Removals is a London-based removals and man-and-van business focused on careful, reliable moves." canonical={`https://${BRAND.domain}/about`} />
            <section className="bg-[#001B3D] text-white">
                <div className="container-ys section">
                    <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "About" }]} />
                    <h1 className="mt-3 text-4xl sm:text-5xl font-semibold tracking-tight font-heading">About YS Removals</h1>
                    <p className="mt-3 text-white/85 max-w-2xl">A London-based removals and man-and-van business focused on careful, reliable moves.</p>
                </div>
            </section>
            <section className="container-ys section grid lg:grid-cols-2 gap-8 items-center">
                <div>
                    <h2 className="text-2xl font-heading font-semibold">A calm, considerate approach</h2>
                    <p className="mt-3 text-[#17252D]/80">We’re focused on making moves feel calmer and more predictable. That means clear communication, tailored quotations, and a considerate team that treats your belongings with respect.</p>
                    <ul className="mt-4 space-y-2">
                        {TRUST_POINTS.map((p) => <li key={p} className="flex items-start gap-2"><CheckCircle2 className="h-4 w-4 mt-1 text-[#001B3D]" /> {p}</li>)}
                    </ul>
                </div>
                <div className="rounded-2xl overflow-hidden border border-[#17252D]/10">
                    <img src={IMAGES.services} alt="Removals team at work" className="h-full w-full object-cover aspect-[4/3]" />
                </div>
            </section>
            <CtaBand />
        </div>
    );
}
